// components/ProtectedLayout.jsx
import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet, Navigate } from "react-router-dom";
import MappingHeader from "../Mapping/pages/Header/MappingHeader";

const ProtectedRoute = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <MappingHeader />
      <div className="">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default ProtectedRoute;
